(function () {
  'use strict';
  var KEY = 'bl_wishlist_boards_v1';
  var MAX_LINK = 7000;
  var cache = new Map();
  var activeItem = null, currentBoardId = null, sharedBoard = null, lastFocus = null, renderVersion = 0;
  var page, content, toolbar, modal, backdrop, searchField, boardOptions, editorModal, editorForm, editorReturnFocus, editorMode = 'create', editorBoardId = null;

  function uid() { return 'board-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9); }
  function defaultState() { return { version: 1, boards: [{ id: uid(), name: 'Wishlist', private: true, items: [] }] }; }
  function cleanItem(item) {
    var handle = String(item && item.handle || '').trim();
    if (!/^[a-z0-9][a-z0-9-]*$/.test(handle)) return null;
    return { handle: handle, variantId: String(item.variantId || ''), quantity: Math.max(1, Math.min(999, Number(item.quantity) || 1)) };
  }
  function normalize(value) {
    if (!value || !Array.isArray(value.boards)) return defaultState();
    var boards = value.boards.slice(0, 50).map(function (b) {
      return { id: String(b.id || uid()).slice(0, 80), name: String(b.name || 'Untitled board').slice(0, 60), private: b.private !== false,
        items: Array.isArray(b.items) ? b.items.slice(0, 150).map(cleanItem).filter(Boolean) : [] };
    });
    return { version: 1, boards: boards.length ? boards : defaultState().boards };
  }
  function read() { try { return normalize(JSON.parse(localStorage.getItem(KEY))); } catch (error) { return defaultState(); } }
  var state = read();
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); }
    catch (error) { toast('Browser storage is unavailable. Your change may not persist.'); }
    updateIndicators();
    window.dispatchEvent(new CustomEvent('bl:wishlist:changed'));
  }
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function toast(message) {
    var node = document.querySelector('[data-bl-wishlist-toast]');
    if (!node) return;
    node.textContent = message;
    node.hidden = false;
    clearTimeout(toast.timer);
    toast.timer = setTimeout(function () { node.hidden = true; }, 3000);
  }
  function key(item) { return item.handle + ':' + item.variantId; }
  function hasProduct(handle) {
    return state.boards.some(function (b) { return b.items.some(function (item) { return item.handle === handle; }); });
  }
  function updateIndicators() {
    var unique = new Set();
    state.boards.forEach(function (b) { b.items.forEach(function (i) { unique.add(key(i)); }); });
    document.querySelectorAll('[data-bl-wishlist-count]').forEach(function (node) {
      node.textContent = String(unique.size);
      node.hidden = unique.size === 0;
    });
    document.querySelectorAll('[data-bl-wishlist-trigger]').forEach(function (node) {
      var pressed = hasProduct(node.dataset.handle);
      node.setAttribute('aria-pressed', String(pressed));
      node.title = pressed ? 'Manage saved boards' : 'Save to board';
    });
  }
  function productRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function getProduct(handle) {
    if (!cache.has(handle)) {
      cache.set(handle, fetch(productRoot() + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); }));
    }
    return cache.get(handle);
  }
  function productLink(item) { return '/products/' + encodeURIComponent(item.handle) + (item.variantId ? '?variant=' + encodeURIComponent(item.variantId) : ''); }
  function variantFrom(product, item) {
    var variants = product.variants || [];
    if (item.variantId) return variants.find(function (v) { return String(v.id) === String(item.variantId); }) || null;
    return variants[0] || null;
  }
  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100); }
    catch (error) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
  }
  function selectionFromButton(button) {
    var variantId = button.dataset.variantId || '';
    if (button.closest('media-gallery')) {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var urlVariant = new URLSearchParams(location.search).get('variant');
      variantId = (input && input.value) || urlVariant || variantId;
    }
    return cleanItem({ handle: button.dataset.handle, variantId: variantId, quantity: 1 });
  }
  function openModal(item) {
    if (!modal || !backdrop) return;
    activeItem = item;
    lastFocus = document.activeElement;
    modal.hidden = false; backdrop.hidden = false;
    document.body.classList.add('bl-wishlist-open');
    if (searchField) searchField.value = '';
    renderModalBoards();
    var title = modal.querySelector('#bl-wishlist-modal-title');
    if (title) title.textContent = activeItem ? 'Save to board' : 'My boards';
    if (searchField) searchField.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.hidden = true; backdrop.hidden = true;
    document.body.classList.remove('bl-wishlist-open');
    if (lastFocus && lastFocus.isConnected && lastFocus.focus) lastFocus.focus();
    activeItem = null;
  }
  function renderModalBoards() {
    if (!boardOptions) return;
    var term = (searchField && searchField.value || '').trim().toLowerCase();
    boardOptions.textContent = '';
    var matchingBoards = state.boards.filter(function (board) {
      return board.name.toLowerCase().includes(term);
    });
    matchingBoards.forEach(function (board) {
      var selected = !!(activeItem && board.items.some(function (saved) {
        return key(saved) === key(activeItem);
      }));
      var isDefaultBoard = state.boards[0] && board.id === state.boards[0].id;
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'bl-wishlist-board-row' + (selected ? ' is-saved' : '');
      row.dataset.blToggleBoard = board.id;
      row.setAttribute('aria-pressed', String(selected));
      row.setAttribute('aria-label', (selected ? 'Remove from ' : 'Save to ') + board.name);
      var thumb = document.createElement('span');
      thumb.className = 'bl-wishlist-board-row__thumb';
      thumb.setAttribute('aria-hidden', 'true');
      var fallback = document.createElement('span');
      fallback.className = 'bl-wishlist-board-row__fallback';
      fallback.textContent = '♡';
      thumb.appendChild(fallback);
      var details = document.createElement('span');
      details.className = 'bl-wishlist-board-row__details';
      var title = document.createElement('strong');
      title.textContent = board.name;
      var subtitle = document.createElement('small');
      var count = board.items.length;
      subtitle.textContent = (isDefaultBoard ? 'Default · ' : '') + count + (count === 1 ? ' item' : ' items');
      details.appendChild(title);
      details.appendChild(subtitle);
      var stateIcon = document.createElement('span');
      stateIcon.className = 'bl-wishlist-board-row__circle';
      stateIcon.setAttribute('aria-hidden', 'true');
      if (selected) stateIcon.textContent = '✓';
      row.appendChild(thumb);
      row.appendChild(details);
      row.appendChild(stateIcon);
      boardOptions.appendChild(row);
      if (board.items.length) {
        var item = board.items[0];
        getProduct(item.handle).then(function (product) {
          if (!row.isConnected || !product) return;
          var source = product.featured_image || (product.images || [])[0];
          if (!source) return;
          var img = document.createElement('img');
          img.src = source;
          img.alt = '';
          img.loading = 'lazy';
          thumb.textContent = '';
          thumb.appendChild(img);
        }).catch(function () { /* Keep neutral placeholder. */ });
      }
    });
    if (!matchingBoards.length) {
      var empty = document.createElement('p');
      empty.className = 'bl-wishlist-board-row__empty';
      empty.textContent = 'No boards found';
      boardOptions.appendChild(empty);
    }
  }
  function toggleBoard(id) {
    var board = state.boards.find(function (b) { return b.id === id; });
    if (!board) return;
    if (!activeItem) { currentBoardId = id; sharedBoard = null; closeModal(); renderPage(); return; }
    var index = board.items.findIndex(function (i) { return key(i) === key(activeItem); });
    if (index >= 0) { board.items.splice(index, 1); toast('Removed from ' + board.name); }
    else { board.items.push(Object.assign({}, activeItem)); toast('Saved to ' + board.name); }
    save(); renderModalBoards(); renderPage();
  }
  function createBoard(name, isPrivate) {
    name = String(name || '').trim().slice(0, 60);
    if (!name) return;
    if (state.boards.length >= 50) { toast('Maximum number of boards reached.'); return; }
    var board = { id: uid(), name: name, private: isPrivate !== false, items: activeItem ? [Object.assign({}, activeItem)] : [] };
    state.boards.push(board); save(); closeModal(); currentBoardId = board.id; sharedBoard = null;
    renderPage(); toast('Board created');
  }
  function activeBoard() { return sharedBoard || state.boards.find(function (b) { return b.id === currentBoardId; }); }
  function renderBoardCovers(container, board) {
    if (!board.items.length) {
      container.innerHTML = '<span class="bl-wishlist-cover-placeholder" aria-hidden="true">♡</span>';
      return;
    }
    var items = board.items.slice(0, 5);
    (async function () {
      for (var i = 0; i < items.length; i++) {
        try {
          var product = await getProduct(items[i].handle);
          if (!container.isConnected) return;
          var src = product.featured_image || (product.images || [])[0];
          if (!src) continue;
          container.textContent = '';
          var img = document.createElement('img');
          img.src = src;
          img.alt = product.title || 'Saved product';
          img.loading = 'lazy'; container.appendChild(img);
          return;
        } catch (error) { /* Try the next product. */ }
      }
      if (container.isConnected) container.textContent = 'Products unavailable';
    })();
  }
  function openEditor(mode, board) {
    if (!editorModal || !editorForm) return;
    editorMode = mode; editorBoardId = board && board.id || null;
    editorReturnFocus = document.activeElement;
    editorForm.reset();
    editorForm.elements.name.value = mode === 'rename' && board ? board.name : '';
    editorForm.elements.privacy.checked = mode === 'rename' && board ? board.private !== false : true;
    editorModal.querySelector('[data-bl-editor-title]').textContent = mode === 'rename' ? 'Rename board' : 'Create a board';
    editorModal.querySelector('[data-bl-editor-submit]').textContent = mode === 'rename' ? 'Save Changes' : 'Create Board';
    editorModal.hidden = false;
    document.body.classList.add('bl-wishlist-editing');
    editorForm.elements.name.focus();
  }
  function closeEditor() {
    if (!editorModal) return;
    editorModal.hidden = true;
    document.body.classList.remove('bl-wishlist-editing');
    if (editorReturnFocus && editorReturnFocus.isConnected && editorReturnFocus.focus) editorReturnFocus.focus();
    editorMode = 'create'; editorBoardId = null;
  }
  function deleteBoard(id) {
    var board = state.boards.find(function (b) { return b.id === id; });
    if (!board || !confirm('Delete "' + board.name + '" and all its saved products?')) return;
    state.boards = state.boards.filter(function (b) { return b.id !== id; });
    if (!state.boards.length) state.boards = defaultState().boards;
    if (currentBoardId === id) currentBoardId = null;
    save(); renderPage(); toast('Board deleted');
  }
  function renderPage() {
    if (!page || !content) return;
    renderVersion++;
    var version = renderVersion;
    var board = activeBoard();
    var notice = page.querySelector('[data-bl-shared-notice]');
    if (notice) notice.hidden = !sharedBoard;
    var signInPrompt = page.querySelector('[data-bl-local-login-banner]');
    if (signInPrompt) signInPrompt.hidden = !!sharedBoard;
    if (toolbar) toolbar.hidden = !board;
    var quote = page.querySelector('[data-bl-quote-wrap]');
    if (quote) quote.hidden = !quote.querySelector('.bl-wishlist-success');
    var rename = page.querySelector('[data-bl-rename-board]'), del = page.querySelector('[data-bl-delete-board]'), imp = page.querySelector('[data-bl-import-board]');
    if (rename) rename.hidden = !!sharedBoard;
    if (del) del.hidden = !!sharedBoard;
    if (imp) imp.hidden = !sharedBoard;
    content.textContent = '';
    if (!board) {
      var grid = document.createElement('div'); grid.className = 'bl-wishlist-board-grid';
      state.boards.forEach(function (b) {
        var tile = document.createElement('article'); tile.className = 'bl-wishlist-board-card';
        tile.innerHTML =
          '<div class="bl-wishlist-board-card__visual">' +
            '<button type="button" class="bl-wishlist-board-card__cover" data-bl-open-board="' + esc(b.id) + '" aria-label="Open ' + esc(b.name) + '"></button>' +
            '<span class="bl-wishlist-board-card__status"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>' + (b.private !== false ? 'PRIVATE' : 'LINK SHARING') + '</span>' +
            '<details class="bl-wishlist-board-card__menu"><summary aria-label="Board options for ' + esc(b.name) + '" title="Board options"><span aria-hidden="true">•••</span></summary><div class="bl-wishlist-board-card__dropdown">' +
              '<button type="button" data-bl-rename-card="' + esc(b.id) + '">Rename board</button>' +
              '<button type="button" data-bl-share-card="' + esc(b.id) + '">Share board</button>' +
              '<button type="button" class="bl-wishlist-board-card__delete" data-bl-delete-card="' + esc(b.id) + '">Delete board</button>' +
            '</div></details>' +
          '</div>' +
          '<div class="bl-wishlist-board-card__details"><button type="button" data-bl-open-board="' + esc(b.id) + '" class="bl-wishlist-board-card__name">' + esc(b.name) + '</button><p>' + b.items.length + (b.items.length === 1 ? ' item' : ' items') + '</p></div>';
        grid.appendChild(tile);
        renderBoardCovers(tile.querySelector('.bl-wishlist-board-card__cover'), b);
      });
      var createTile = document.createElement('button');
      createTile.type = 'button';
      createTile.className = 'bl-wishlist-create-tile';
      createTile.setAttribute('data-bl-new-board', '');
      createTile.innerHTML = '<span class="bl-wishlist-create-tile__inner"><span class="bl-wishlist-create-tile__plus" aria-hidden="true">+</span><span class="bl-wishlist-create-tile__title">New board</span><span class="bl-wishlist-create-tile__description">START A NEW COLLECTION</span></span>';
      grid.appendChild(createTile);
      content.appendChild(grid);
      return;
    }
    var h = document.createElement('h2'); h.className = 'bl-wishlist-current-title'; h.textContent = board.name;
    content.appendChild(h);
    if (!board.items.length) {
      var empty = document.createElement('p'); empty.textContent = 'No products saved yet. Explore our lighting collections and tap the heart icon to save a selection.'; content.appendChild(empty);
      return;
    }
    var gridProducts = document.createElement('div'); gridProducts.className = 'bl-wishlist-grid';
    content.appendChild(gridProducts);
    board.items.forEach(function (item, index) {
      var article = document.createElement('article'); article.className = 'bl-wishlist-product'; article.dataset.blItemIndex = String(index);
      article.dataset.blQuoteStatus = 'loading';
      article.innerHTML = '<div class="bl-wishlist-product__media"></div><h3>Loading product...</h3><p></p>' +
        '<div class="bl-wishlist-product__ops"><label><input type="checkbox" data-bl-include checked> Quote</label>' +
        '<label>Qty <input type="number" data-bl-quantity min="1" max="999" value="' + item.quantity + '"></label>' +
        (sharedBoard ? '' : '<button type="button" data-bl-remove-item="' + index + '">Remove</button>' + (state.boards.length > 1 ? '<select data-bl-move-to aria-label="Move this product to another board"><option value="">Move to...</option>' + state.boards.filter(function (b) { return b.id !== board.id; }).map(function (b) { return '<option value="' + esc(b.id) + '">' + esc(b.name) + '</option>'; }).join('') + '</select>' : '')) +
        '</div><button type="button" class="bl-wishlist-add-cart" data-bl-add-cart disabled>Loading...</button>';
      gridProducts.appendChild(article);
      getProduct(item.handle).then(function (product) {
        if (!article.isConnected || renderVersion !== version) return;
        var v = variantFrom(product, item), image = (v && v.featured_image && v.featured_image.src) || product.featured_image || (product.images || [])[0];
        var variantMatches = !item.variantId || (v && String(v.id) === String(item.variantId));
        var media = article.querySelector('.bl-wishlist-product__media');
        if (image) { var img = document.createElement('img'); img.src = image; img.alt = product.title || ''; img.loading = 'lazy'; media.appendChild(img); }
        var title = article.querySelector('h3');
        title.innerHTML = '<a href="' + esc(productLink(item)) + '">' + esc(product.title) + '</a>';
        var selected = v && v.title && v.title !== 'Default Title' ? v.title : '';
        article.querySelector('p').textContent = v ? ((selected ? selected + ' · ' : '') + money(v.price)) : 'Previously selected variant is no longer available';
        article.dataset.blTitle = product.title || item.handle;
        article.dataset.blVariant = selected;
        article.dataset.blUrl = location.origin + productLink(item);
        // SKU belongs to the saved product's exact Shopify variant, not the product or its first variant.
        // Variant IDs stay internal for accurate cart and product lookups; quotes display the SKU.
        article.dataset.blQuoteStatus = v && variantMatches ? 'ready' : 'unavailable';
        article.dataset.blSku = v && variantMatches && v.sku ? String(v.sku).trim() : '';
        var cartButton = article.querySelector('[data-bl-add-cart]');
        if (cartButton) {
          var purchasable = v && variantMatches && v.available !== false;
          cartButton.disabled = !purchasable;
          cartButton.textContent = purchasable ? 'Add to Cart' : 'Unavailable';
          if (purchasable) article.dataset.blCartVariant = String(v.id);
        }
      }).catch(function () {
        if (!article.isConnected) return;
        article.querySelector('h3').textContent = 'Product unavailable: ' + item.handle;
        article.querySelector('p').textContent = 'This product may have been removed.';
        article.dataset.blTitle = item.handle; article.dataset.blVariant = ''; article.dataset.blUrl = location.origin + productLink(item);
        article.dataset.blQuoteStatus = 'unavailable';
        article.dataset.blSku = '';
        var cartButton = article.querySelector('[data-bl-add-cart]');
        if (cartButton) { cartButton.textContent = 'Unavailable'; cartButton.disabled = true; }
      });
    });
  }
  function encodeShare(board) {
    var payload = { v: 1, n: board.name, i: board.items.map(function (item) {
      return { h: item.handle, v: item.variantId, q: item.quantity };
    }) };
    var bytes = new TextEncoder().encode(JSON.stringify(payload)), binary = '';
    for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }
  function decodeShare(raw) {
    if (!raw || raw.length > MAX_LINK) throw new Error('Invalid shared link');
    var binary = atob(raw.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - raw.length % 4) % 4));
    var bytes = Uint8Array.from(binary, function (x) { return x.charCodeAt(0); });
    var payload = JSON.parse(new TextDecoder().decode(bytes));
    if (!payload || payload.v !== 1 || !Array.isArray(payload.i) || payload.i.length > 100) throw new Error('Invalid board');
    return { id: 'shared-board', name: String(payload.n || 'Shared Board').slice(0, 60), items: payload.i.map(function (i) {
      return cleanItem({ handle: i.h, variantId: i.v, quantity: i.q });
    }).filter(Boolean) };
  }
  async function copyBoardLink(boardId) {
    var board = boardId ? state.boards.find(function (b) { return b.id === boardId; }) : activeBoard();
    if (!board) { toast('Board could not be found.'); return; }
    if (board.private !== false && !confirm('Create a view-only sharing link for "' + board.name + '"? Anyone with the link can see the products and Board name.')) return;
    var url = location.origin + '/pages/wishlist#blboard=' + encodeShare(board);
    if (url.length > MAX_LINK) { toast('Board too large for a share link. Try a smaller board.'); return; }
    try { await navigator.clipboard.writeText(url); toast('Updated Board link copied'); }
    catch (error) {
      var field = document.createElement('textarea'); field.value = url; field.style.position = 'fixed'; field.style.opacity = '0';
      document.body.appendChild(field); field.select();
      var ok = document.execCommand('copy'); field.remove();
      toast(ok ? 'Updated Board link copied' : 'Unable to copy link. Please try another browser.');
    }
  }
  async function addSavedProductToCart(button) {
    var card = button.closest('[data-bl-item-index]');
    var board = activeBoard();
    if (!card || !board || button.disabled) return;
    var item = board.items[Number(card.dataset.blItemIndex)];
    var variantId = card.dataset.blCartVariant;
    if (!item || !variantId) { toast('Choose available options on the product page.'); return; }
    var quantityInput = card.querySelector('[data-bl-quantity]');
    var quantity = Math.max(1, Math.min(999, Number(quantityInput && quantityInput.value) || item.quantity || 1));
    var root = productRoot();
    button.disabled = true; button.textContent = 'Adding...';
    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: Number(variantId), quantity: quantity })
      });
      if (!response.ok) {
        var problem = await response.json().catch(function () { return {}; });
        throw new Error(problem.description || problem.message || 'Unable to add item');
      }
      toast('Added to cart');
      window.location.assign(root + 'cart');
    } catch (error) {
      toast(error.message || 'Unable to add to cart');
      button.disabled = false; button.textContent = 'Add to Cart';
    }
  }
  function showQuote() {
    var board = activeBoard(); if (!board || !board.items.length) { toast('Save products to this Board first.'); return; }
    var quote = page && page.querySelector('[data-bl-quote-wrap]'); if (!quote) return;
    quote.hidden = false; quote.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function prepareQuote(event) {
    var board = activeBoard(); if (!board) { event.preventDefault(); return; }
    var rows = Array.from(content.querySelectorAll('.bl-wishlist-product')).filter(function (el) {
      return el.querySelector('[data-bl-include]') && el.querySelector('[data-bl-include]').checked;
    });
    if (!rows.length) { event.preventDefault(); toast('Select at least one product to quote.'); return; }
    if (rows.some(function (row) { return row.dataset.blQuoteStatus === 'loading'; })) {
      event.preventDefault(); toast('Please wait while product details load before submitting your quote.'); return;
    }
    if (rows.some(function (row) { return row.dataset.blQuoteStatus !== 'ready'; })) {
      event.preventDefault(); toast('A selected product or size is unavailable. Please deselect it or update the selection.'); return;
    }
    var form = event.target;
    var lines = ['REQUEST A QUOTE', 'Board: ' + board.name, 'Selected products: ' + rows.length, ''];
    rows.forEach(function (row, idx) {
      var i = Number(row.dataset.blItemIndex), item = board.items[i], qty = Math.max(1, Math.min(999, Number(row.querySelector('[data-bl-quantity]').value) || 1));
      lines.push((idx + 1) + '. ' + (row.dataset.blTitle || item.handle));
      lines.push('Product URL: ' + (row.dataset.blUrl || (location.origin + productLink(item))));
      lines.push('SKU: ' + (row.dataset.blSku || 'Not assigned'));
      if (row.dataset.blVariant) lines.push('Options: ' + row.dataset.blVariant);
      lines.push('Quantity: ' + qty, '');
    });
    var notes = form.querySelector('[name="contact[Project notes]"]'), project = form.querySelector('[name="contact[Project type]"]');
    if (project) lines.push('Project type: ' + project.value);
    if (notes && notes.value.trim()) lines.push('Project details: ' + notes.value.trim());
    form.querySelector('[data-bl-quote-body]').value = lines.join('\n');
  }
  function init() {
    page = document.querySelector('[data-bl-wishlist-page]');
    content = page && page.querySelector('[data-bl-wishlist-content]');
    toolbar = page && page.querySelector('[data-bl-board-toolbar]');
    modal = document.getElementById('bl-wishlist-modal'); backdrop = document.getElementById('bl-wishlist-backdrop');
    editorModal = document.getElementById('bl-wishlist-editor');
    editorForm = editorModal && editorModal.querySelector('[data-bl-editor-form]');
    searchField = modal && modal.querySelector('[data-bl-board-search]');
    boardOptions = modal && modal.querySelector('[data-bl-board-options]');
    var shareMatch = location.hash.match(/^#blboard=([^&]+)/);
    if (page && shareMatch) {
      try { sharedBoard = decodeShare(shareMatch[1]); }
      catch (error) { toast('This shared Wishlist link is invalid.'); }
    }
    if (searchField) searchField.addEventListener('input', renderModalBoards);
    if (editorForm) editorForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var name = editorForm.elements.name.value.trim().slice(0, 60);
      var isPrivate = editorForm.elements.privacy.checked;
      if (!name) { editorForm.elements.name.focus(); return; }
      if (editorMode === 'rename') {
        var edited = state.boards.find(function (b) { return b.id === editorBoardId; });
        if (edited) { edited.name = name; edited.private = isPrivate; save(); renderPage(); toast('Board updated'); }
        closeEditor();
      } else {
        closeEditor(); createBoard(name, isPrivate);
      }
    });
    if (page) {
      var quote = page.querySelector('#bl-wishlist-quote-form');
      if (quote) quote.addEventListener('submit', prepareQuote);
    }
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-bl-wishlist-trigger]');
      if (trigger) {
        event.preventDefault(); event.stopPropagation();
        var selectedItem = selectionFromButton(trigger);
        if (selectedItem) openModal(selectedItem);
        return;
      }
      var btn = event.target.closest('button[data-bl-toggle-board],button[data-bl-open-board],button[data-bl-remove-item],button[data-bl-new-board],button[data-bl-editor-open],button[data-bl-close-modal],button[data-bl-all-boards],button[data-bl-rename-board],button[data-bl-delete-board],button[data-bl-rename-card],button[data-bl-share-card],button[data-bl-delete-card],button[data-bl-import-board],button[data-bl-share-board],button[data-bl-show-quote],button[data-bl-hide-quote],button[data-bl-close-editor],button[data-bl-add-cart]');
      if (!btn) return;
      if (btn.hasAttribute('data-bl-add-cart')) { event.preventDefault(); addSavedProductToCart(btn); return; }
      if (btn.hasAttribute('data-bl-close-editor')) { closeEditor(); return; }
      if (btn.hasAttribute('data-bl-rename-card')) {
        var editedCard = state.boards.find(function (b) { return b.id === btn.dataset.blRenameCard; });
        if (editedCard) openEditor('rename', editedCard);
        return;
      }
      if (btn.hasAttribute('data-bl-share-card')) {
        event.preventDefault();
        var cardMenu = btn.closest('details');
        if (cardMenu) cardMenu.open = false;
        copyBoardLink(btn.dataset.blShareCard);
        return;
      }
      if (btn.hasAttribute('data-bl-delete-card')) { deleteBoard(btn.dataset.blDeleteCard); return; }
      if (btn.hasAttribute('data-bl-toggle-board')) toggleBoard(btn.dataset.blToggleBoard);
      else if (btn.hasAttribute('data-bl-open-board')) { currentBoardId = btn.dataset.blOpenBoard; sharedBoard = null; renderPage(); }
      else if (btn.hasAttribute('data-bl-remove-item')) {
        var board = activeBoard(); if (sharedBoard || !board) return;
        board.items.splice(Number(btn.dataset.blRemoveItem), 1); save(); renderPage();
      }
      else if (btn.hasAttribute('data-bl-new-board') || btn.hasAttribute('data-bl-editor-open')) openEditor('create', null);
      else if (btn.hasAttribute('data-bl-close-modal')) closeModal();
      else if (btn.hasAttribute('data-bl-all-boards')) { currentBoardId = null; sharedBoard = null; history.replaceState(null, '', location.pathname + location.search); renderPage(); }
      else if (btn.hasAttribute('data-bl-rename-board')) {
        var board = activeBoard(); if (!board || sharedBoard) return;
        openEditor('rename', board);
      }
      else if (btn.hasAttribute('data-bl-delete-board')) {
        var board = activeBoard(); if (!board || sharedBoard) return;
        deleteBoard(board.id);
      }
      else if (btn.hasAttribute('data-bl-import-board')) {
        if (!sharedBoard) return;
        if (state.boards.length >= 50) { toast('Maximum number of boards reached.'); return; }
        var added = { id: uid(), name: sharedBoard.name, items: sharedBoard.items.map(function (i) { return Object.assign({}, i); }) };
        state.boards.push(added); sharedBoard = null; currentBoardId = added.id;
        history.replaceState(null, '', location.pathname + location.search); save(); renderPage(); toast('Board saved to this browser');
      }
      else if (btn.hasAttribute('data-bl-share-board')) copyBoardLink();
      else if (btn.hasAttribute('data-bl-show-quote')) showQuote();
      else if (btn.hasAttribute('data-bl-hide-quote')) { var q = page.querySelector('[data-bl-quote-wrap]'); if (q) q.hidden = true; }
    }, true);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    if (editorModal) editorModal.addEventListener('click', function (event) { if (event.target === editorModal) closeEditor(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (editorModal && !editorModal.hidden) closeEditor();
        else if (modal && !modal.hidden) closeModal();
      }
      if (e.key !== 'Tab') return;
      var dialog = editorModal && !editorModal.hidden ? editorModal.querySelector('.bl-wishlist-editor__panel') : (modal && !modal.hidden ? modal : null);
      if (!dialog) return;
      var tabbable = Array.from(dialog.querySelectorAll('button:not([disabled]),input:not([disabled]),a[href],select:not([disabled])')).filter(function (node) { return node.getClientRects().length; });
      if (!tabbable.length) return;
      if (e.shiftKey && document.activeElement === tabbable[0]) { e.preventDefault(); tabbable[tabbable.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === tabbable[tabbable.length - 1]) { e.preventDefault(); tabbable[0].focus(); }
    });
    if (content) content.addEventListener('change', function (event) {
      if (event.target.matches('[data-bl-move-to]')) {
        var source = activeBoard(), destination = state.boards.find(function (b) { return b.id === event.target.value; });
        var sourceCard = event.target.closest('[data-bl-item-index]');
        if (!source || !destination || !sourceCard || sharedBoard) return;
        var moved = source.items.splice(Number(sourceCard.dataset.blItemIndex), 1)[0];
        if (moved && !destination.items.some(function (i) { return key(i) === key(moved); })) destination.items.push(moved);
        save(); renderPage(); toast('Product moved to ' + destination.name);
        return;
      }
      if (!event.target.matches('[data-bl-quantity]')) return;
      var board = activeBoard(), card = event.target.closest('[data-bl-item-index]');
      if (!board || !card) return;
      var item = board.items[Number(card.dataset.blItemIndex)];
      if (!item) return;
      item.quantity = Math.max(1, Math.min(999, Number(event.target.value) || 1));
      event.target.value = item.quantity;
      if (!sharedBoard) save();
    });
    window.addEventListener('storage', function (event) { if (event.key === KEY) { state = read(); updateIndicators(); renderModalBoards(); renderPage(); } });
    document.addEventListener('shopify:section:load', updateIndicators);
    updateIndicators(); renderPage();
  }
  // Narrow, non-sensitive integration surface for customer-authenticated cloud sync.
  window.BlingWishlistStore = {
    snapshot: function () { return JSON.parse(JSON.stringify(state)); },
    replaceFromCloud: function (incoming) {
      state = normalize(incoming);
      try { localStorage.setItem(KEY, JSON.stringify(state)); }
      catch (error) { toast('Browser storage is unavailable; cloud copy remains available.'); }
      updateIndicators();
      renderModalBoards();
      renderPage();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();